<template>
  <div class="Coupons " :class="!couponLength ? 'noData-bg' : ''">
        <app-header class="Coupons-head" :title="$t('coupons.coupons_name')" @on-click="goBack"></app-header>
        <div class="coupons-list">
            <div class="no-coupons" v-if="!couponLength">
                <img src="../../assets/imgs/login/noCoupons.png" alt="">
                <span class="tips-noData">{{$t('coupons.no_coupons')}}</span>
            </div>
            <!--  -->
            <div v-for="coupon in couponsList" :key="coupon.id" class="coupons-item-con" @click="goCouponGoodsList(coupon)">
                <div class="coupons-item">
                    <div class="coupons-num" :class="'coupons-num-' + coupon.promotionMode">
                        <span class="coupons-amount">{{coupon.quota}}{{['P01','P03'].includes(coupon.promotionMode) ? '%' : ''}}</span>
                        <span class="coupons-curr">{{ ['P01','P03'].includes(coupon.promotionMode) ? 'OFF' : currencyType}}</span>
                    </div>
                    <div class="coupons-desc">
                        <span class="coupons-title van-ellipsis">{{coupon.name}}</span>
                        <div>
                            <div class="coupons-type van-ellipsis">{{coupon.title}}</div>
                            <div class="coupons-time">{{coupon.effectiveDate | filterTime}} - {{coupon.expiryDate | filterTime}}</div>
                            <img class="coupons-show-img" :src="coupon.isShow ? hide : expend" alt="" @click.stop="onSwitchIsShow(coupon)">
                        </div>
                    </div>
                </div>
                <transition name="fade">
                    <div v-show="coupon.isShow" class="coupons-details">
                        <span>{{coupon.remark}}</span>
                    </div>
                </transition>
            </div>
        </div>
  </div>
</template>

<script>
import expend from '../../assets/imgs/login/expand.png'
import hide from '../../assets/imgs/login/hide.png'
import cookie from "../../utils/cookie";
import dateUtil from "../../utils/DateUtil";
export default {
    name:'Coupons',
    data() {
        let currencyType = JSON.parse(localStorage.getItem("userInfo"))?.currencyType || JSON.parse(sessionStorage.getItem("urlData"))?.currencyType;
        return {
            expend,
            hide,
            isShow:false,
            couponsList:[],
            currencyType: currencyType,
        }
    },
    filters:{
        filterTime(time) {
            if (!time) return "";
            let dateFormat = 'yyyy/MM/dd HH:mm'
            let langType = cookie.getCookie('langType')
            if(['es-ES','pt-PT','de-DE','fr-FR','it-IT','tr-TR'].includes(langType)){
                dateFormat = 'dd/MM/yyyy HH:mm'
            }
            return dateUtil.formatDateTime(new Date(time), dateFormat);
        },
    },
    computed:{
        couponLength(){
            return this.couponsList?.length
        },
    },
    mounted(){
        this.httpGetCouponsList()
    },
    methods:{
        goBack() {
            this.$router.go(-1);
            sessionStorage.removeItem('data-selectedCoupon');
        },
        onSwitchIsShow(item) {
            item.isShow = !item.isShow
        },
        // 跳转适用该优惠券页面
        goCouponGoodsList(coupon) {
            sessionStorage.setItem('data-selectedCoupon', JSON.stringify(coupon));
            this.$router.push(this.$setRouteQuery({
                name:'CouponGoodsList',
                query:{
                    promotionCode: coupon.promotionCode,
                }
            },this))
            let mode = {
                P01:'满减百分比',
                P02:'满减金额',
                P03:'直减百分比',
                P04:'直减金额'
            }
            // 神策-点击优惠券
            this.$sensors.track('WebCouponClick', {
                coupon_id: coupon.promotionId,
                coupon_code: coupon.promotionCode,
                coupon_name: coupon.promotionName['zh-CN'] || coupon.promotionName['en-US'] || '',
                coupon_amount: coupon.quota,
                coupon_mode: mode[coupon.promotionMode],
                coupon_effective_date: dateUtil.formatDateTime(new Date(coupon.effectiveDate), 'yyyy-MM-dd HH:mm'),
                coupon_expiry_date: dateUtil.formatDateTime(new Date(coupon.expiryDate), 'yyyy-MM-dd HH:mm'),
            });
        },
        //接口查询个人优惠券
        httpGetCouponsList() {
                let sessionStorageUrlData = JSON.parse(sessionStorage.urlData) || {};
                this.$http.post({
                    url:'/bss/app/promotion/queryPromotionInst',
                    data: {
                        currentPage: 1,
                        perPageCount: 1000,
                        loginCustomerId: sessionStorageUrlData.loginCustomerId,
                        status:'AVAILABLE'
                    }
                }).then(res => {
                    if(res.data && res.data.dataList && res.data.dataList.length > 0) {
                        this.couponsList = res.data.dataList.map(item => {
                            let title = item.promotionTitle[this.$i18n.locale] || item.promotionTitle['en-US'] || '';
                            let name = item.promotionName[this.$i18n.locale] || item.promotionName['en-US'] || '';
                            let remark = item.promotionRemark[this.$i18n.locale] || item.promotionRemark['en-US'] || '';
                            return {
                                ...item,
                                isShow:false,
                                title,
                                name,
                                remark
                            }
                        }); 
                    }
                }).catch(err => {
                    this.$toast(err)
                });
        },
    }
}
</script>

<style lang="less" scoped>
@import "css/index.less";
</style>